

export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

export function typeOf(obj) {
  const type = Object.prototype.toString.call(obj);
  return type.substring(8, type.length - 1);
}

export function filterSize(size) {
  if (!size) return '-'
  if (size < pow1024(1)) return size + ' B'
  if (size < pow1024(2)) return (size / pow1024(1)).toFixed(2) + ' KB'
  if (size < pow1024(3)) return (size / pow1024(2)).toFixed(2) + ' MB'
  if (size < pow1024(4)) return (size / pow1024(3)).toFixed(2) + ' GB'
  return (size / pow1024(4)).toFixed(2) + ' TB'
}

function pow1024(num) {
  return Math.pow(1024, num)
}
